import classNames from 'classnames'
import Img from 'gatsby-image'
import React, { useEffect, useRef } from 'react'
import { useInView } from 'react-intersection-observer'

import { ContentfulAsset } from '../../../@import-types/contentful/Asset.types'
import { PageColorDataProps } from '../../../constants/GlobalDOM'
import useAnimationLoop from '../../../hooks/useAnimationLoop'
import useElementBounds from '../../../hooks/useElementBounds'
import useOnMount from '../../../hooks/useOnMount'
import useWindowSize from '../../../hooks/useWindowSize'
import useForceRender from '../../../hooks/utils/useForceRender'
import useTimeout from '../../../hooks/utils/useTimeout'
import Blob from '../../../utils/blob-classes/Blob'
import SpringPoint from '../../../utils/blob-classes/SpringPoint'
import LayoutContainer from '../../_layouts/LayoutContainer'
import HeroHeading from '../../_typography/HeroHeading'

import styles from './video-hero.module.scss'

interface VideoHeroProps {
  title: string | null | undefined
  description?: string | null
  media: ContentfulAsset | null | undefined
  className?: string
  poster?: ContentfulAsset | null | undefined
}

export default function VideoHero({
  title,
  description,
  media,
  className,
  poster,
}: VideoHeroProps) {
  useWindowSize()

  const videoRef = useRef<HTMLVideoElement>(null)
  const { ref, inView } = useInView({
    initialInView: true,
    threshold: 0.25,
  })

  const isVideo = media?.file?.contentType?.includes('video')
  const isImage = media?.file?.contentType?.includes('image')

  useEffect(() => {
    if (inView) {
      videoRef?.current?.play()
    } else {
      videoRef?.current?.pause()
    }
  }, [inView])

  return (
    <div
      ref={ref}
      className={classNames(styles.container, className)}
      {...PageColorDataProps}
    >
      {isImage && media && media.fluid && (
        <Img
          className={styles.posterImage}
          fluid={media?.fluid}
          alt={media.description || media.title || ''}
        />
      )}
      {isVideo && media && (
        <>
          {poster?.fluid && (
            <Img
              className={styles.posterImage}
              fluid={poster.fluid}
              alt={media.description || media.title || ''}
            />
          )}
          <video
            className={styles.heroVideo}
            id="videoPlayer"
            src={media?.file?.url}
            title={media.description || media.title || ''}
            ref={videoRef}
            preload={'none'}
            autoPlay
            muted
            loop
          />
        </>
      )}

      <LayoutContainer className={styles.textsContainer}>
        <div className={styles.textColumn}>
          <HeroHeading className={styles.title}>{title}</HeroHeading>
        </div>

        {description && (
          <div className={styles.textColumn}>
            <p className={styles.description}>{description}</p>
          </div>
        )}
      </LayoutContainer>
    </div>
  )
}

// From VideoHero - 2 years ago

// const pathElRef = useRef<SVGPathElement>(null)
// const { elementRef: containerElRef, elementBoundsRef } = useElementBounds<
//   HTMLDivElement
// >()

// const _setTimeout = useTimeout()
// const stopTimeoutIdRef = useRef(-1)

// const [blob] = useState(
//   () =>
//     new Blob({
//       pointCount: 10,
//       radius: 250,
//       pointRadiusOffset: 0.1,
//       pointSpeedOffset: 0.0005,
//     })
// )

// const [position] = useState(() => new SpringPoint(170, 30))

// const { start, stop } = useAnimationLoop((time) => {
//   blob.update(time)
//   position.update(time.elapsedS)

//   const pathEl = pathElRef.current
//   if (pathEl) {
//     pathEl.setAttribute('d', blob.toSvgPathD())
//     pathEl.setAttribute('transform', `translate(${position.x} ${position.y})`)
//   }
// })

// const forceRender = useForceRender()
// useOnMount(forceRender)

// function onMouseEnter(event: React.MouseEvent<HTMLElement, MouseEvent>) {
//   clearTimeout(stopTimeoutIdRef.current)

//   start()
//   blob.appear()

//   position.targetX = event.pageX
//   position.targetY = event.pageY
// }

// function onMouseLeave(event: React.MouseEvent<HTMLElement, MouseEvent>) {
//   stopTimeoutIdRef.current = _setTimeout(stop, 500)
// }

// function onMouseMove(event: React.MouseEvent<HTMLElement, MouseEvent>) {
//   position.targetX = event.pageX
//   position.targetY = event.pageY
// }

// Outer div
// ref={containerElRef}
// onMouseEnter={onMouseEnter}
// onMouseLeave={onMouseLeave}
// onMouseMove={onMouseMove}
